import React from "react";
import { Divider, ListItem } from "@mui/material";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { LabelImportantOutlined } from "@mui/icons-material";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CustomIcon from "../CustomIcon/CustomIcon";
import InfoListCardSubSection from "./components/InfoListCardSubSection";
import * as Styles from "./InfoListCard.styles";

interface InfoListType {
  label: string;
  value: string;
}

interface InfoListCardPropsType {
  title: string;
  highLightIcon?: React.ReactNode;
  highLightValue: string;
  highLightLabel: string;
  listItemIcon?: React.ReactNode;
  listItems: InfoListType[];
  subSectionTitle: string;
  subSectionIcon?: React.ReactNode;
  subSectionItems: InfoListType[];
}

export default function InfoListCard({
  title,
  highLightIcon,
  highLightLabel,
  highLightValue,
  listItemIcon,
  listItems,
  subSectionTitle,
  subSectionIcon,
  subSectionItems,
}: InfoListCardPropsType) {
  return (
    <Styles.CustomCardContainer elevation={1}>
      <Styles.CustomHeaderContainer>
        <Styles.CustomHeaderTitle>
          <CustomIcon Icon={LabelImportantOutlined} color="var(--color-primary)" />
          {title}
        </Styles.CustomHeaderTitle>

        <Styles.CustomHighLightTextContainer>
          {highLightIcon ?? <CustomIcon Icon={CalendarMonthRoundedIcon} size={"var(--icon-size-sm)"} color="currentColor" />}
          <Styles.CustomHighLightText>
            {highLightLabel}: {highLightValue}
          </Styles.CustomHighLightText>
        </Styles.CustomHighLightTextContainer>
      </Styles.CustomHeaderContainer>

      <Styles.CustomCardBodyContainer>
        {listItems.map((item, index) => (
          <ListItem disablePadding key={index}>
            <Styles.CustomListItemIcon>
              {listItemIcon ?? <CustomIcon Icon={DescriptionOutlinedIcon} size={"var(--icon-size-lg)"} color="currentColor" />}
            </Styles.CustomListItemIcon>
            <Styles.CustomListItemText
              primary={
                <>
                  <strong>{item.label}: </strong>
                  {item.value}
                </>
              }
            />
          </ListItem>
        ))}

        <Divider />

        <InfoListCardSubSection
          subSectionTitle={subSectionTitle}
          subSectionItems={subSectionItems}
          subSectionIcon={subSectionIcon ?? <CustomIcon Icon={BusinessRoundedIcon} size={"var(--icon-size-lg)"} color="currentColor" />}
        />
      </Styles.CustomCardBodyContainer>
    </Styles.CustomCardContainer>
  );
}
